import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration object
const firebaseConfig = {
    apiKey: "AIzaSyCHn9zRcpjKkZ5bMQ7Qz0UDpMoHwDDz1xQ",
    authDomain: "kvkemployee.firebaseapp.com",
    projectId: "kvkemployee",
    storageBucket: "kvkemployee.firebasestorage.app",
    messagingSenderId: "600823397029",
    appId: "1:600823397029:web:d5d0c35b41b25862cceb4c",
    measurementId: "G-JB71JF8L6L"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app); // For authentication
export const db = getFirestore(app); // For Firestore database
export const storage = getStorage(app); // For Firestore database
